module.exports = __webpack_public_path__ + "img/git.f8e8ddbc.svg";